import _ from 'underscore';

export const getStyles = ({
  calloutCloseButton,
  calloutCloseButtonIcon,
  calloutTargetContainer,
  calloutTitle,
  calloutFooter,
}) => {
  const defaulCalloutCloseButton = {
    border: '0',
    background: 'inherit',
    width: '12px',
    maxWidth: '12px',
    minWidth: '12px',
    height: '13px',
    maxHeight: '13px',
    minHeight: '13px',
    padding: '0',
    position: 'absolute',
    top: '9px',
    right: '8px',
  };
  const defaulCalloutCloseButtonIcon = {
    fontSize: '12px !important',
    lineHeight: '13px !important',
    margin: '0 !important',
    top: '-4px !important',
    position: 'relative !important',
  };
  const defaulCalloutTargetContainer = {
    width: 'fit-content',
    height: 'fit-content',
  };
  const defaultCalloutFooter = {
    paddingTop: '15px',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  };
  const defaultCalloutTitle = {
    display: 'flex',
    alignItems: 'center',
  };

  // No default styles
  const calloutTitleIcon = {
    marginRight: '6px',
    fontSize: '20px !important',
    position: 'static !important',
  };
  const actions = {
    marginTop: '16px',
    borderTop: '1px solid #EDEBE9',
  };
  const footerActionList = {
    display: 'flex',
    alignItems: 'center',
  };

  return ({
    calloutCloseButton: _.extend(defaulCalloutCloseButton, calloutCloseButton),
    calloutCloseButtonIcon: _.extend(defaulCalloutCloseButtonIcon, calloutCloseButtonIcon),
    calloutTargetContainer: _.extend(defaulCalloutTargetContainer, calloutTargetContainer),
    calloutTitle: _.extend(defaultCalloutTitle, calloutTitle),
    calloutFooter: _.extend(defaultCalloutFooter, calloutFooter),
    calloutTitleIcon,
    actions,
    footerActionList,
  });
};

